'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tsTabset", function () {
  return {
    restrict: "E",
    replace: true,
    transclude: true,
    scope: true,
    template: '' + '<div class="ts-tabset">' + '   <div class="ts-tab-pills {{headersClass}} has-{{tabs.length}}-tabs">' + '       <ts-tab-pill ng-repeat="tab in tabs | orderBy:tabSorterFn track by tab.tabId"></ts-tab-pill>' + '   </div>' + '   <div class="ts-tab-contents {{contentsClass}}">' + '       <ts-tab-box ng-repeat="tab in tabs | filter:isNotButton track by tab.tabId"></ts-tab-pill>' + '   </div>' + '   <div class="ts-tabs"></div>' + '</div>',
    controller: function controller($scope) {
      var ctrl = this,
        tabs = ctrl.tabs = $scope.tabs = [],
        initialTabId = null;
      $scope.isNotButton = function (tab) {
        return !tab.isButton;
      };
      $scope.tabSorterFn = function (tab) {
        return tab.el.index();
      };
      var findTabById = function findTabById(tabId) {
        return _.find(tabs, {
          tabId: tabId
        });
      };
      ctrl.setInitialTab = function (tabId) {
        initialTabId = tabId;
      };
      ctrl.selectTab = function selectTab(tab) {
        tab = _.isString(tab) ? findTabById(tab) : tab;
        _.each(tabs, function (tab) {
          tab.active = false;
        });
        tab.active = true;
      };
      ctrl.addTab = function addTab(tab, index) {
        tabs.splice(index || 0, 0, tab);
        if (tabs.length === 1 || tab.active || initialTabId === tab.tabId) {
          ctrl.selectTab(tab);
        } else {
          tab.active = false;
        }
      };
      ctrl.removeTab = function removeTab(tab) {
        var index = tabs.indexOf(tab);
        if (tab.active && tabs.length > 1) {
          var newActiveIndex = index === tabs.length - 1 ? index - 1 : index + 1;
          ctrl.selectTab(tabs[newActiveIndex]);
        }
        tabs.splice(index, 1);
      };
    },
    link: function link($scope, $el, $attrs, ctrl, transcludeFn) {
      $attrs.$observe("headersClass", function (headersClass) {
        $scope.headersClass = headersClass;
      });
      $attrs.$observe("contentsClass", function (contentsClass) {
        $scope.contentsClass = contentsClass;
      });
      transcludeFn($scope, function (children) {
        $el.find(".ts-tabs").append(children);
      });

      // ts-tabset-id

      var selectTabHandler = function selectTabHandler(event, tabId) {
        event.stopPropagation && event.stopPropagation(); // check for broadcast events...
        ctrl.selectTab(tabId);
      };
      $scope.$on("tsTabset:selectTab", selectTabHandler);
      if ($attrs.tsTabsetId) {
        $scope.$on("tsTabset:" + $attrs.tsTabsetId + ":selectTab", selectTabHandler);
      }

      // ts-tabset-initial-tab

      if ($attrs.tsTabsetInitialTab) {
        ctrl.setInitialTab($attrs.tsTabsetInitialTab);
      }
    }
  };
});
ngModule.directive("tsTab", function () {
  return {
    restrict: "E",
    require: "^tsTabset",
    scope: true,
    transclude: true,
    controller: function controller($scope) {
      var ctrl = this;
      ctrl.getTab = function () {
        return $scope.tab;
      };
    },
    compile: function compile(element, attrs, transcludeFn) {
      return {
        pre: function pre($scope, $el, $attrs, tabsetCtrl) {
          var tab = $scope.tab = {
            tabId: $attrs["tsTabId"] || _.uniqueId("tsTab-"),
            isButton: false,
            el: $el,
            scope: $scope,
            active: _.has($attrs, "active"),
            onSelect: function onSelect() {
              if ($attrs.select) {
                $scope.$eval($attrs.select);
              }
            },
            onUnselect: function onUnselect() {
              if ($attrs.unselect) {
                $scope.$eval($attrs.unselect);
              }
            }
          };
          $attrs.$observe("headerClass", function (headersClass) {
            tab.headerClass = headersClass;
          });
          $scope.$watch("tab.active", function (isActive, oldValue) {
            if (isActive === oldValue) {
              return;
            }
            isActive ? tab.onSelect() : tab.onUnselect();
          });

          // what we do here is finding the highter level from where the tab directive was imported.
          // this is useful when doing specific tab's directive,
          // which require a wrapper div to avoid multiple replace on same directive element.
          var tabChild = $el;
          while (tabChild.parent().get(0) != null && !tabChild.parent().is("div.ts-tabs")) {
            tabChild = tabChild.parent();
          }
          var position = tabChild.index();
          tabsetCtrl.addTab(tab, position);
          transcludeFn($scope, function (children) {
            $el.append(children);
          });
          $scope.$on('$destroy', function () {
            tabsetCtrl.removeTab(tab);

            // we remove the box & pill now, to avoid the blinking effect from deletion from tabset.
            if (tab.$boxScope) {
              tab.$boxScope.$destroy();
              tab.$box.remove();
            }
            if (tab.$pillScope) {
              tab.$pillScope.$destroy();
              tab.$pill.remove();
            }
          });

          // no longer need the wrapper element.
          // Next steps will be done using the tab transclude fn in content and header
          $el.hide();
        }
      };
    }
  };
});
ngModule.directive("tsTabButton", function () {
  return {
    restrict: "E",
    require: "^tsTabset",
    scope: true,
    transclude: true,
    controller: function controller($scope) {},
    compile: function compile(element, attrs, transcludeFn) {
      return {
        pre: function pre($scope, $el, $attrs, tabsetCtrl) {
          var tab = $scope.tab = {
            tabId: $attrs["tsTabId"] || _.uniqueId("tsTab-"),
            isButton: true,
            el: $el,
            scope: $scope,
            onClick: function onClick() {
              if ($attrs.click) {
                $scope.$eval($attrs.click);
              }
            }
          };
          $attrs.$observe("headerClass", function (headersClass) {
            tab.headerClass = headersClass;
          });
          var position = $el.index();
          tabsetCtrl.addTab(tab, position);
          tab.$headerTranscludeFn = transcludeFn;
          $scope.$on('$destroy', function () {
            tabsetCtrl.removeTab(tab);
          });
          $el.hide();
        }
      };
    }
  };
});
ngModule.directive("tsTabHeader", function () {
  return {
    restrict: "E",
    require: "^tsTab",
    transclude: true,
    link: function link($scope, $el, $attrs, tabCtrl, transcludeFn) {
      var tab = tabCtrl.getTab();
      tab.$headerTranscludeFn = transcludeFn;
    }
  };
});
ngModule.directive("tsTabContent", function () {
  return {
    restrict: "E",
    require: "^tsTab",
    transclude: true,
    link: function link($scope, $el, $attrs, tabCtrl, transcludeFn) {
      var tab = tabCtrl.getTab();
      tab.$contentTranscludeFn = transcludeFn;
    }
  };
});
ngModule.directive("tsTabPill", function (directiveUtils, $mdButtonInkRipple) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: "^tsTabset",
    template: '<div class="ts-tab-pill {{tab.headerClass}}" ng-click="onPillClick()" ng-class="{selected : tab.active}"></div>',
    link: function link($scope, $el, $attrs, tabsetCtrl) {
      var tab = $scope.tab = $scope.$eval("tab");
      tab.$pill = $el;
      tab.$pillScope = $scope;
      $mdButtonInkRipple.attach($scope, $el);
      directiveUtils.copyControllers(tab.el, $el);
      $el.attr("ts-tab-id", tab.tabId);
      $scope.onPillClick = function () {
        if (tab.isButton) {
          tab.onClick();
        } else {
          tabsetCtrl.selectTab(tab);
        }
      };
      var unwatchTransclude = $scope.$watch(function () {
        return tab.$headerTranscludeFn;
      }, function (transcludeFn) {
        if (transcludeFn == null) {
          return;
        }
        unwatchTransclude();
        transcludeFn(tab.scope, function (contents) {
          $el.append(contents);
        });
      });
    }
  };
});
ngModule.directive("tsTabBox", function (directiveUtils) {
  return {
    restrict: "E",
    replace: true,
    require: "hideableContainer",
    scope: true,
    template: '<div hideable-container class="ts-tab-content autosize-reference"></div>',
    link: function link($scope, $el, $attrs, visibilityCtrl) {
      var tab = $scope.tab = $scope.$eval("tab");
      tab.$box = $el;
      tab.$boxScope = $scope;
      if (!tab.active) {
        $el.hide();
      }
      directiveUtils.copyControllers(tab.el, $el);
      var transcluded = false;
      $scope.$watch("tab.active", function (active) {
        $el[active ? "show" : "hide"]();
        visibilityCtrl.setVisible(tab.active);
        if (active && !transcluded) {
          tab.$contentTranscludeFn(tab.scope, function (tabContent) {
            $el.append(tabContent);
          });
          transcluded = true;
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/structure/tsTabset.js
// module id = 3007
// module chunks = 13